{
  "remove": "Премахване"
}
